import { gql } from 'graphql-tag';

const locationContactQuery = gql`
  query apmsLocationContactsList($locationId: Int, $page: Int, $size: Int) {
    apmsLocationContactsList(
      locationId: $locationId
      page: $page
      size: $size
    ) {
      locationId
      auctionName
      contacts {
        contactId
        contactName
        title
        isBlockedEmail
        contactEmail
        phone
        contactType
        guaranteeConfirm
        guaranteeCancel
        returns
        vehNotCovered
        createdAt
        updatedAt
      }
    }
  }
`;

export default locationContactQuery;
